import moment from 'moment';
import React from 'react';
import {
  DeliveredMuchTimeAgo,
  DeliveredToday,
  DeliveredYesterday,
  DeliverySoon,
  DeliveryUntilToday,
  DeliveryUntilTomorrow
} from './status-eta-message-components';
import { IN_RECIPIENT } from './status.constants';

const formatEta = eta => {
  // The moment() should not be abstracted to a constant
  // because the operator to add and subtract the time could be fail
  const deliveryDate = moment.unix(eta);

  const deliveryDateFormated = deliveryDate
    .format('LL')
    .slice(0, -8)
    .toLowerCase();

  return { deliveryDate, deliveryDateFormated };
};

const isYesterday = deliveryDate => {
  const yesterdayDate = moment().subtract(1, 'days');
  return deliveryDate.isSame(yesterdayDate, 'day');
};

const isToday = deliveryDate => {
  return deliveryDate.isSame(moment(), 'day');
};

const isTomorrow = deliveryDate => {
  const tomorrowDate = moment().add(1, 'days');
  return deliveryDate.isSame(tomorrowDate, 'day');
};

const delivery = {
  isYesterday,
  isToday,
  isTomorrow
};

const getEtaStatusMessage = (eta, packageStatus, receivedBy) => {
  const { deliveryDate, deliveryDateFormated } = formatEta(eta);

  const packageDelivered = packageStatus === IN_RECIPIENT;

  const shouldBeTodayMessage = delivery.isToday(deliveryDate);

  const shouldBeYesterdayMessage =
    packageDelivered && delivery.isYesterday(deliveryDate);

  const shouldBeTomorrowMessage =
    !packageDelivered && delivery.isTomorrow(deliveryDate);

  if (shouldBeYesterdayMessage) {
    return (
      <DeliveredYesterday
        dateTime={deliveryDate.format('LT')}
        receivedBy={receivedBy}
      />
    );
  }

  if (shouldBeTodayMessage && !packageDelivered) {
    return <DeliveryUntilToday />;
  }

  if (shouldBeTodayMessage && packageDelivered) {
    return (
      <DeliveredToday
        dateTime={deliveryDate.format('LT')}
        receivedBy={receivedBy}
      />
    );
  }

  if (shouldBeTomorrowMessage) {
    return <DeliveryUntilTomorrow />;
  }

  if (packageDelivered) {
    return (
      <DeliveredMuchTimeAgo
        date={deliveryDateFormated}
        dateTime={deliveryDate.format('LT')}
        receivedBy={receivedBy}
      />
    );
  }

  return <DeliverySoon date={deliveryDateFormated} />;
};

export default getEtaStatusMessage;
